/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { memo, useContext, useEffect, useState, useId } from 'react';
import { Box, DialogTitle, Grid, Stack, Typography } from '@mui/material';
import { IoIosArrowDown } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { roleCondition, userFullName } from '../../../../../../libs/HelperContent';
import ShareCreation from '../ShareCreation';
import { getSocialAccDetails } from './CustomHooks/useGetSocialAccnts';
import ProfilePic from '../../../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../../../libs/Context';
import useFeedApproval from '../CustomHooks/useFeedApproval';

const CreateFeedHeader = (props) =>
{
	const { relations, createFeedAs, handleChange, requestT, handleClickCancel, feedCreator, relationsRef, departmentsRef, getDepartmentsList } = props;
	const userData = useSelector((state:any) => state?.mysession?.session);
	const companyUser = useSelector((state:any) => state?.mysession?.configs);
	const currentUser = useSelector((state:any) => state?.mysession?.userConfigs);
	const { isFeedsAdmin } = useFeedApproval();
	const canPostAsCompany = isFeedsAdmin;
	const [ openShare, setOpenShare ] = useState<boolean>(false);
	const tempId = useId();

	const [ socialAccounts, setSocialAccnts ] = useState<any>({
		socialDetails : [],
		isShareEnable : false
	});
	const { isShareEnable, socialDetails } = socialAccounts;
	const { language } = useContext(LanguageContext);

	const userEnabledModules = currentUser?.socialMediaConfiguration?.moduleEnabled ?? [];
	const checkUserEnable = requestT === 'driveUpload'
		? userEnabledModules.includes('newsFeed') && userEnabledModules.includes('mediaDrive')
		: userEnabledModules.includes('newsFeed');

	const userCheck = ((currentUser?.socialMediaConfiguration?.isSocialEnable && checkUserEnable) || false);

	const isSocialEnable = roleCondition(userData?.empRole)
		? createFeedAs === 'self'
			? userCheck
			: ((companyUser?.socialMediaConfiguration?.isSocialEnable) || false)
		: userCheck;

	const handleOpenShare = () =>
	{
		setOpenShare(true);
	};

	const getSocialConfigDetails = async () =>
	{
		if (Object?.keys(companyUser)?.length > 0 && Object?.keys(companyUser)?.length > 0)
		{
			if ((!roleCondition(userData?.empRole) || createFeedAs !== 'company') && currentUser?.socialMediaConfiguration?.isSocialEnable)
			{
				const { Socialaccnts } = await getSocialAccDetails(companyUser, currentUser, userData, createFeedAs, requestT);

				setSocialAccnts((prev) => ({ ...prev, socialDetails: Socialaccnts }));
			}
			if (createFeedAs === 'company' && companyUser?.socialMediaConfiguration?.isSocialEnable)
			{
				const { Socialaccnts } = await getSocialAccDetails(companyUser, currentUser, userData, createFeedAs, requestT);

				setSocialAccnts((prev) => ({ ...prev, socialDetails: Socialaccnts }));
			}
		}
	};

	useEffect(() =>
	{
		const isShareEnab =
		// createFeedAs === 'self'
			// ? (socialDetails?.length > 0 && isSocialEnable)
			// : 
			relationsRef?.current?.length > 0 || (socialDetails?.length > 0 && isSocialEnable);

		setSocialAccnts((prev) => ({ ...prev, isShareEnable: isShareEnab }));
	}, [ createFeedAs, socialDetails, relationsRef?.current ]);

	useEffect(() =>
	{
		getSocialConfigDetails();
		getDepartmentsList();
	}, [ createFeedAs ]);

	const textClr = (isShareEnable && userData.role !== 'individual') ? 'var(--primaryColor)' : 'var(--lightGreyColor)';
	const pointerStyle = (isShareEnable && userData.role !== 'individual') ? 'pointer' : '';

	return (
		<DialogTitle>
			<Grid container alignItems={'center'} flexDirection={'row'}>
				<Grid item xs>
					<Stack direction={'row'} spacing={1} alignItems={'center'}>
						<Box display='inline-flex'width='var(--pixel32)'height='var(--pixel32)'>
							<ProfilePic
								from={createFeedAs === 'company' ? '' : 'selfProfile'}
								imagePath={
									createFeedAs === 'company'
										? `${userData?.companyId}_logo.jpeg?t=${tempId}`
										: `${userData?.userId}.jpeg?t=${tempId}`
								}
								// imagePath={
								// 	`${createFeedAs === 'company'
								// 		? userData?.companyId
								// 		: userData?.userId}_${[ 'self' ].includes(createFeedAs)
								// 		? 'profile'
								// 		: 'logo'}.jpeg?t=${new Date().valueOf()}`
								// }
								defaultImg={([ 'self' ].includes(createFeedAs) ? '/images/icons/defaultUser.svg' : '/images/logos/no_logo.png')}
								alt='createdBy'
								className='brdrRadius50 pointer objectFitCover'
							/>
						</Box>
						<Stack direction='column'>
							{canPostAsCompany && requestT !== 'editFeeds'
								? <Stack direction={'row'} spacing={1} alignItems='center'>
									{createFeedAs === 'company'
										? 	<>
											<Typography fontWeight='var(--font500)'>{userData?.companyName}</Typography>
											<Box
												component='img'
												src='/images/icons/EmployeeIconPost.svg'
												alt='CompanyIconPost'
												sx={{
													width  : 'var(--pixel20)',
													height : 'var(--pixel20)',
													cursor : 'pointer'
												}}
												onClick={() => handleChange('self')}
											/>
										</>
										: <>
											<Typography fontWeight='var(--font500)'>
												{userFullName(userData)}
											</Typography>
											<Box
												component='img'
												src='/images/icons/CompanyIconPost.svg'
												alt='EmployeeIconPost'
												sx={{
													width  : 'var(--pixel20)',
													height : 'var(--pixel20)',
													cursor : 'pointer'
												}}
												onClick={() => handleChange('company')}
											/>
										</>
									}
								</Stack>
								: (
									<Stack direction={'row'} spacing={1} alignItems='center'>
										<Typography fontWeight='var(--font500)'>
											{!feedCreator || (feedCreator === userData?.userId)
												? userFullName(userData)
												: userData?.companyName}
										</Typography>
									</Stack>
								)
							}
							<Typography
								variant='body2'
								color={textClr}
								display='flex'
								alignItems='center'
								onClick={() =>
								{
									(userData.role !== 'individual') && handleOpenShare();
								}}
								sx={{ cursor: pointerStyle }}
							>
								{/* {(roleCondition(userData?.empRole) || createFeedAs === 'company' || userData?.empRole === 'employee') */}
								{userData.role !== 'individual'
									? <>
										{relations?.find((rel) => rel?.relation === 'company internal employees')
											? language.employees
											: typeof relations?.[0] === 'string'
												? relations?.[0]?.replace(`${userData?.companyId}-`, '')
												: relations?.[0]?.relation || ''
										}
										{relations?.length > 1 ? ` ${relations?.length - 1}+` : ''}
									</>
									: ''
								}
								{userData.role !== 'individual' && <IoIosArrowDown fontSize={14} style={{ marginLeft: 'var(--pixel4)' }} />}
							</Typography>
						</Stack>
					</Stack>

				</Grid>
				<Grid item>
					<IoClose onClick={handleClickCancel} style={{ cursor: 'pointer' }} fontSize={'var(--pixel20)'}/>
				</Grid>
			</Grid>
			{openShare && (
				<ShareCreation
					open={openShare}
					handleClose={() => setOpenShare(false)}
					relationsRef={relationsRef}
					departmentsRef={departmentsRef}
					createFeedAs={createFeedAs}
					requestT={requestT}
					socialAccounts={socialDetails}
					isSocialEnable={isSocialEnable}
					showRelationsForEmployee={createFeedAs === 'self'}
				/>)}
			{/* ) */}
			{/* } */}
		</DialogTitle>
	);
};

export default memo(CreateFeedHeader);